import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['text', 'copyIcon', 'checkIcon', 'button'];
  static values = {
    content: String,
    linkText: String,
    linkUrl: String,
    successMessage: { type: String, default: 'Text copied to clipboard!' },
    errorMessage: { type: String, default: 'Unable to copy. Please try again.' }
  };

  connect() {
    this.resetIcons();
  }

  async copy(event) {
    event?.preventDefault();

    try {
      if (this.hasLinkTextValue && this.hasLinkUrlValue) {
        await this.copyAsLink();
      }
      else {
        const content = this.hasContentValue
          ? this.contentValue
          : this.hasTextTarget
            ? this.textTarget.innerText
            : '';

        if (!content) {
          this.showNotification('error', this.errorMessageValue);
          return;
        }

        await navigator.clipboard.writeText(content);
      }

      this.showNotification('success', this.successMessageValue);
      this.toggleIcons();
    } catch (error) {
      console.error('Clipboard error:', error);
      this.showNotification('error', this.errorMessageValue);
    }
  }

  async copyAsLink() {
    const html = `<a href="${this.linkUrlValue}">${this.linkTextValue}</a>`;
    const plainText = `${this.linkTextValue}\n${this.linkUrlValue}`;

    const clipboardItem = new ClipboardItem({
      'text/html': new Blob([html], { type: 'text/html' }),
      'text/plain': new Blob([plainText], { type: 'text/plain' })
    });

    await navigator.clipboard.write([clipboardItem]);
  }

  showNotification(type, message) {
    window.dispatchEvent(new CustomEvent('notification:show', {
      detail: { type, message }
    }));
  }

  toggleIcons() {
    if (this.hasCopyIconTarget && this.hasCheckIconTarget) {
      if (this.iconTimeout) {
        clearTimeout(this.iconTimeout);
      }

      this.copyIconTarget.classList.add('hidden');
      this.checkIconTarget.classList.remove('hidden');

      this.iconTimeout = setTimeout(() => this.resetIcons(), 2000);
    }
  }

  resetIcons() {
    if (this.hasCopyIconTarget && this.hasCheckIconTarget) {
      this.copyIconTarget.classList.remove('hidden');
      this.checkIconTarget.classList.add('hidden');
    }
  }

  disconnect() {
    if (this.iconTimeout) {
      clearTimeout(this.iconTimeout);
    }
  }
}
